import { render, staticRenderFns } from "./SupportListView.vue?vue&type=template&id=0586a0b6"
import script from "./SupportListView.vue?vue&type=script&lang=js"
export * from "./SupportListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports